import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import type {
  DevicePeopleExportQuery,
  DevicePeopleSearchQuery,
} from "../-types";

export const getDevicePeople = async (params: DevicePeopleSearchQuery) => {
  const res = await apiClient.GET("/v2/device-people", {
    params: {
      query: params,
    },
  });
  return getDataOrThrowApiError(res);
};

export const getDevicePeopleCount = async () => {
  const res = await apiClient.GET("/v2/device-people/count");
  return getDataOrThrowApiError(res);
};

export const getDevicePeopleExport = async (
  params: DevicePeopleExportQuery,
) => {
  const res = await apiClient.GET("/v2/device-people-csv", {
    params: {
      query: { ...params, mode: "view", encoding: "UTF-8" },
    },
  });
  return getDataOrThrowApiError(res);
};
